import { createRoot } from "react-dom/client";

import { brand } from "./constants/brandVariables/brandVariables";
import App from "./App.tsx";

// Mirror the resolved brand onto <html> so stylesheets can scope rules that
// have to sit on the root element — the rem base used for TV scaling can't be
// written as a descendant of the in-app `.theme-*` wrapper.
if (brand?.themeId) {
  document.documentElement.classList.add(`brand-${brand.themeId}`);
}

createRoot(document.getElementById("root")!).render(<App />);
